/** @format */

import { useQuery } from "@tanstack/react-query";
import service from "../utils/service";
import { SURVEY } from "../constants/constants";

const useGetSummarySurveyReport = (surveyId, enabled = true, status) => {
  const isActiveSurvey = status && SURVEY.STATUS.ACTIVE.toLocaleLowerCase() === status.toLocaleLowerCase();
  const allSurvey = useQuery({
    queryKey: ["getSummarySurveyReport", surveyId],
    queryFn: () => service.getSurveySummary(surveyId),
    select: (data) => data.data,
    enabled,
    cacheTime: isActiveSurvey ? 0 : Infinity,
    staleTime: isActiveSurvey ? 0 : Infinity,
  });
  return allSurvey;
};

export default useGetSummarySurveyReport;
